module.exports = __webpack_public_path__ + "img/red-7.c5a4ade0.png";